<template>
  <PageTemplate>
    <template v-slot:page-content>
      <b-container fluid id="page-container">
        <div id="content-container-with-border">
          <h1>Privacy and Cookies</h1>
          <h2>COOKIES POLICY</h2>
          <p>
            To make this site work properly, we sometimes place small data files
            called cookies on your device.
          </p>

          <h2>WHAT ARE COOKIES?</h2>
          <p>
            A cookie is a small text file that a website saves on your computer
            or mobile device when you visit the site. It helps the website to
            remember your actions and preferences (such as login, language, font
            size and other display preferences) over a period of time, so you
            don't have to keep re-entering them whenever you come back to the
            site or browse from one page to another.
          </p>

          <h2>HOW DO WE USE COOKIES?</h2>
          <p>A number of our pages use cookies to remember:</p>

          <ul>
            <li>
              your display preferences, such as contrast colour settings or font
              size
            </li>
            <li>
              if you have already replied to a survey pop-up that asks you if
              the content was helpful or not (so you won't be asked again)
            </li>
            <li>
              if you have agreed (or not) to our use of cookies on this site
            </li>
          </ul>

          <p>
            There is a list of the cookies we use set out below. The cookies are
            classed as:
          </p>

          <ul>
            <li>Strictly necessary cookies</li>
            <li>Functional cookies</li>
            <li>Performance cookies</li>
            <li>We do not use Advertising Cookies on this website</li>
          </ul>

          <h2>DO WE USE OTHER COOKIES?</h2>
          <p>
            Some of our pages or sub-sites may use additional or different
            cookies to the ones described above. If so, the details of these
            will be provided in their specific cookies notice page. So you may
            be asked for your agreement to store these cookies.
          </p>

          <h2>JUST BROWSING?</h2>
          <p>
            You will not be contacted by us if you just look around the site. We
            will only contact you if you complete a call back or contact
            request. If you want to know more about how we use your data please
            see our Privacy Statement.
          </p>

          <h2>HOW TO CONTROL COOKIES</h2>
          <p>
            You can control and/or delete cookies as you wish - for details, see
            AllAboutCookies.org. You can delete all cookies that are already on
            your computer and you can set most browsers to prevent them from
            being placed.
          </p>

          <CookieTable />

          <p>
            If you choose to manage or delete the cookies used, you may have to
            manually adjust some preferences every time you visit a site, and
            some services and functionalities may not work.
          </p>

          <h2>COOKIES IN MORE DETAIL</h2>
          <p>
            The rest of this section gives you a list of what performance
            cookies are set by our website and a description of how they are
            used.
          </p>

          <h2>ANALYTICS SOFTWARE</h2>
          <p>
            PayPoint use hosted web analytics software. These are hosted
            services provided and managed by third party companies. PayPoint's
            main supplier of hosted web analytics and recordings are Google,
            Inc. and App Dynamics. This website uses Google Analytics, a web
            analytics service provided by Google, Inc. ("Google"), as well as
            App Dynamics, who are part of the Cisco Group.
          </p>
          <p>
            Google Analytics & App Dynamics use "cookies", which are text files
            placed on your computer, to help the website analyse how users use
            the site. This is to help inform future product enhancements and
            improvements, and to diagnose any defects quicker.
          </p>
          <p>
            The information generated by the cookie regarding our websites
            (including IP addresses) will be transmitted to and stored by Google
            and Cisco on servers that may be hosted in the United States. Google
            and AppDynamics will use this information for the purpose of
            evaluating use of our website, compiling reports on website activity
            for website operators and providing other related services to
            PayPoint. Please visit
            <a href="https://analytics.google.com/analytics/web/#/provision"
              >Google website</a
            >
            and
            <a href="https://www.appdynamics.com/">AppDynamics website</a> for
            more information regarding privacy.
          </p>
          <p>
            By accepting these cookies you consent to the processing of data
            about you by Google, Inc. and Cisco Systems Inc. in the manner and
            for the purposes set out above.
          </p>
        </div>
      </b-container>
    </template>
  </PageTemplate>
</template>

<script>
import PageTemplate from "Components/PageTemplate";
import CookieTable from "./CookieTable";

export default {
  name: "Privacy",
  components: {
    PageTemplate,
    CookieTable,
  },
  data() {
    return {
      data: null,
    };
  },
};
</script>

<style lang="scss" scoped>
@import "Design/_variables.scss";
@import "Design/paypoint-form-common-styles.scss";

#paypoint-privacy-page {
  background-color: $color-brand-light-blue-grey;
  position: relative;
  height: 100%;
}
</style>
